// @flow

import React from 'react';
import { ThemeProvider as UIThemeProvider } from 'trpc-react-native-ui';
import theme from '../../../theme-config';

type ThemeProviderProps = {
  children: any,
  themeName: string,
};

export default ({ children, themeName }: ThemeProviderProps) => (
  <UIThemeProvider key={themeName} theme={theme.ui}>
    {children}
  </UIThemeProvider>
);
